<template lang="html">
  <div>
    <div class="Kanit ">
      <v-toolbar style="color: #5eca33; background-color: black;" fixed dark>
        <v-toolbar-items class="borderXwidth">
          <v-btn class="fontset hidden-sm-and-down " flat @click="toPage('/')" ><v-icon style="font-size: 25px !important;">home</v-icon></v-btn>
          <v-btn class="fontset hidden-md-and-up " flat @click="toPage('/')" ><v-icon style="font-size: 25px !important;">home</v-icon></v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-toolbar-items class="borderXwidth">
          <v-btn class="fontset" flat @click="toPage('/register')"  v-if="myname == null">สมัครสมาชิก</v-btn>
          <v-btn class="fontset"  @click="toPage('/login')" flat  v-if="myname == null">ลงชื่อเข้าใช้</v-btn>
          <v-btn class="fontset"  @click="toPage('/login')" flat v-else>
            <v-avatar size="50px"   style="margin-right: 1vw !important;">
              <img v-if="filename != ''" :src="filename" class="alligator-turtle" style="cursor: pointer;">
              <v-img v-else src='../../static/img/robot/developer1.png' class="alligator-turtle" style="cursor: pointer;"/>
            </v-avatar>
            <!-- {{myname}} -->
            <p class="textlayoutnavbar">{{myname}}</p>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </div>

  </div>
</template>

<script>
export default {
  data: () => ({
    myname: '',
    filename: ''
  }),
  methods: {
    toPage (page) {
      console.log(page)
      this.$router.push(page)
      // this.$router.replace({
      //   path: page,
      //   query: {
      //     term: '#',
      //     sort: page
      //   }
      // }).catch(err => {})
    }
  },
  watch: {
    myprofile () {
      this.filename = localStorage.getItem('profilepicture')
      this.myname = localStorage.getItem('name')
      // console.log(localStorage.getItem('name'))
    }
  },
  created () {
    // console.log('jam')
    // console.log(localStorage.getItem('name'))
    // if()
    this.myname = localStorage.getItem('name')
    this.filename = localStorage.getItem('profilepicture')
  }
}
</script>

<style lang="css" scoped>
div.borderXwidth a:before, div.borderXwidth a:after
{
    position: absolute;
    opacity: 0;
    width: 0%;
    height: 2px;
    content: '';
    /*background: #02d700;*/
    background: gray;
    transition: all 0.3s;
}

div.borderXwidth a:before
{
    left: 0px;
    top: 0px;
}

div.borderXwidth a:after
{
    right: 0px;
    bottom: 0px;
}

div.borderXwidth a:hover:before, div.borderXwidth a:hover:after
{
    opacity: 1;
    width: 100%;
}
.fontset{
  font-weight: bold !important;
  font-family: 'CS ChatThaiUI' !important;
  font-size:17px !important;
  /*font-weight: 900px;*/
}
.setbtn{
  margin-top: 17vw !important;
}
.btn .btn__content .icon {
    color: inherit;
    font-size: 11px !important;
}
.carousel__controls {
  height: 24px;
}
.textlayoutnavbar {
  white-space: nowrap;
  width: 5em;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 0vw;
  padding-top: 1vh;
  padding-left: 0vw !important;
  font-family: 'CS ChatThaiUI', sans-serif !important;
  font-size: 18px;
  padding-bottom: 0px;
  color: white;
  text-transform: none;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Navbarapi.vue